import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { Button, Input, Row, Col, Label } from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";

const auth = () => ({ headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } });
const hoy = () => new Date().toLocaleDateString("en-CA", { timeZone: "America/Mexico_City" });

// Alta de empleado: crea al colaborador y, si tiene acceso, su usuario (sin permisos;
// los permisos se dan en Usuarios). Si trabaja en una tienda, su usuario queda limitado a esa tienda.
function ColaboradoresCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_PUESTOS = process.env.REACT_APP_URL_PUESTOS;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;
  const URL_AREAS = process.env.REACT_APP_URL_AREAS;
  const URL_USERS = process.env.REACT_APP_URL_USERS;
  const PLANTELES_GENERAL = process.env.REACT_APP_PLANTELES_GENERAL;
  const AREAS_GENERAL = process.env.REACT_APP_AREAS_GENERAL;

  const [nombre, setNombre] = useState("");
  const [apellido, setApellido] = useState("");
  const [email, setEmail] = useState("");
  const [telefono, setTelefono] = useState("");
  const [puestos, setPuestos] = useState([]);
  const [puesto, setPuesto] = useState("");
  const [areas, setAreas] = useState([]);
  const [area, setArea] = useState(AREAS_GENERAL);
  const [fechaIngreso, setFechaIngreso] = useState(hoy());
  const [acceso, setAcceso] = useState("Si");
  const [password] = useState(() => Math.random().toString(36).slice(2, 8));
  const [guardando, setGuardando] = useState(false);

  useEffect(() => {
    axios.get(URL_PUESTOS, auth()).then((r) => setPuestos(r.data.filter((p) => p.is_active !== "No"))).catch(() => {});
    axios.get(URL_AREAS, auth()).then((r) => setAreas(r.data.filter((a) => a.is_active !== "No"))).catch(() => {});
  }, [URL_PUESTOS, URL_AREAS]);

  const tiendas = areas.filter((a) => a.tienda).sort((a, b) => (a.name > b.name ? 1 : -1));
  const oficinas = areas.filter((a) => !a.tienda).sort((a, b) => (a.name > b.name ? 1 : -1));
  const enTienda = tiendas.some((t) => t._id === area);

  const guardar = async (e) => {
    e.preventDefault();
    const correo = email.trim().toLowerCase();
    if (!nombre.trim() || !apellido.trim() || !correo || !puesto || !fechaIngreso) {
      return Swal.fire({ icon: "warning", title: "Faltan datos", text: "Nombre, apellido, correo, puesto y fecha de ingreso son obligatorios." });
    }
    setGuardando(true);
    try {
      if (acceso === "Si") {
        const ya = await axios.get(`${URL_USERS}/email/${encodeURIComponent(correo)}`, auth());
        if (ya.data && ya.data.length) {
          setGuardando(false);
          return Swal.fire({ icon: "warning", title: "Ese correo ya tiene usuario", text: "Usa otro correo para este empleado." });
        }
      }
      await axios.post(URL_COLABORADORES, {
        nombre: nombre.trim(), apellido: apellido.trim(), email: correo, telefono: telefono.trim(),
        puestos: puesto, planteles: PLANTELES_GENERAL, areas: area, fecha_ingreso: fechaIngreso,
        ultimo_aumento: fechaIngreso, sueldo_anterior: 0, acceso_sistema: acceso,
      }, auth());
      const col = await axios.get(`${URL_COLABORADORES}/email/${encodeURIComponent(correo)}`, auth());
      if (acceso === "Si") {
        await axios.post(URL_USERS, {
          nombre: nombre.trim(), apellido: apellido.trim(), email: correo, password,
          colaboradores: col.data[0]._id, planteles: PLANTELES_GENERAL, areas: area, is_active: "Si",
        }, auth());
      }
      axios.post(URL_LOGS, { tipo: "Crear Empleado", detalle: `Nombre: ${nombre} / Apellido: ${apellido}`, user: user.id }, auth()).catch(() => {});
      await Swal.fire({
        icon: "success",
        title: "Empleado dado de alta",
        html: acceso === "Si"
          ? `Usuario: <b>${correo}</b><br/>Contraseña: <b>${password}</b><br/><br/>Ahora dale sus permisos en <b>Usuarios</b>.${enTienda ? "<br/>Solo podrá trabajar en su tienda." : ""}`
          : "Sin acceso al sistema.",
      });
      window.location.href = "/Empleados";
    } catch (er) {
      Swal.fire({ icon: "error", title: "No se pudo guardar", text: (er.response && er.response.data && er.response.data.message) || "Revisa los datos" });
      setGuardando(false);
    }
  };

  if (!user.empleados_create) {
    return (<><Header /><div className="card container col-12 p-4">No tienes permiso para dar de alta empleados.</div></>);
  }

  return (
    <>
      <Header />
      <div className="card container col-12 col-lg-9" style={{ padding: "20px 24px" }}>
        <div className="page-header">
          <div>
            <h3 className="page-title"><i className="fas fa-user-plus mr-2" style={{ color: "#10b981" }} />Alta de empleado</h3>
            <p className="page-subtitle">Si tiene acceso al sistema se le crea su usuario; los permisos se asignan en Usuarios</p>
          </div>
        </div>
        <form onSubmit={guardar}>
          <Row>
            <Col md={6} className="mb-3"><Label>Nombre</Label><Input value={nombre} onChange={(e) => setNombre(e.target.value)} placeholder="Nombre" /></Col>
            <Col md={6} className="mb-3"><Label>Apellido</Label><Input value={apellido} onChange={(e) => setApellido(e.target.value)} placeholder="Apellido" /></Col>
            <Col md={6} className="mb-3"><Label>Correo (es su usuario)</Label><Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="nombre@ninaferre.com" /></Col>
            <Col md={6} className="mb-3"><Label>Teléfono</Label><Input value={telefono} onChange={(e) => setTelefono(e.target.value)} placeholder="55 1234 5678" /></Col>
            <Col md={6} className="mb-3">
              <Label>Puesto</Label>
              <Input type="select" value={puesto} onChange={(e) => setPuesto(e.target.value)}>
                <option value="">Selecciona un puesto</option>
                {puestos.sort((a, b) => (a.name > b.name ? 1 : -1)).map((p) => <option key={p._id} value={p._id}>{p.name}</option>)}
              </Input>
            </Col>
            <Col md={6} className="mb-3">
              <Label>Trabaja en</Label>
              <Input type="select" value={area} onChange={(e) => setArea(e.target.value)}>
                <optgroup label="Oficina">
                  {oficinas.map((a) => <option key={a._id} value={a._id}>{a.name}</option>)}
                </optgroup>
                <optgroup label="Tiendas">
                  {tiendas.map((a) => <option key={a._id} value={a._id}>{a.clave ? `${a.clave} · ` : ""}{a.name}</option>)}
                </optgroup>
              </Input>
            </Col>
            <Col md={4} className="mb-3"><Label>Fecha de ingreso</Label><Input type="date" value={fechaIngreso} onChange={(e) => setFechaIngreso(e.target.value)} /></Col>
            <Col md={4} className="mb-3">
              <Label>Acceso al sistema</Label>
              <Input type="select" value={acceso} onChange={(e) => setAcceso(e.target.value)}>
                <option value="Si">Sí</option><option value="No">No</option>
              </Input>
            </Col>
            {acceso === "Si" && (
              <Col md={4} className="mb-3"><Label>Contraseña inicial</Label><Input value={password} disabled /></Col>
            )}
          </Row>
          <div className="submit-bar">
            <Button color="secondary" href="/Empleados">Regresar</Button>
            <Button color="success" type="submit" disabled={guardando}>{guardando ? <i className="fas fa-spinner fa-spin" /> : <><i className="fas fa-save mr-1" />Guardar</>}</Button>
          </div>
        </form>
      </div>
    </>
  );
}

export default ColaboradoresCreate;
